<template>
  <q-btn unelevated round icon="notifications" @click="getAllNotifications()">
    <q-badge v-if="unreadNotificationCount > 0" floating color="red" rounded>
      <span class="text-weight-bold">
        {{ unreadNotificationCount }}
      </span>
    </q-badge>

    <q-menu
      :style="`width: ${
        $q.screen.lt.sm ? '100vw' : $q.screen.lt.md ? '50vw' : '30vw'
      }`"
    >
      <p
        class="q-mx-md text-body1 text-weight-medium q-ma-xs"
        :class="this.$q.dark.mode === true ? '' : 'text-primary '"
      >
        Notifications
      </p>
      <q-separator />
      <q-list>
        <q-item>
          <q-item-section>
            <q-list>
              <q-item
                v-for="cn in combinedNotificationList"
                :key="cn.id"
                class="q-px-none cursor-pointer"
              >
                <q-item-section @click="onClickCombineNotification(cn)">
                  <q-item-label
                    class="text-body2 text-weight-medium"
                    :class="
                      $q.dark.mode === true
                        ? cn.viewed
                          ? 'text-grey'
                          : 'text-weight-bold'
                        : cn.viewed
                        ? 'text-grey'
                        : 'text-primary text-weight-bold'
                    "
                  >
                    {{ cn.title }}
                  </q-item-label>
                  <q-item-label
                    caption
                    lines="2"
                    :class="
                      $q.dark.mode === true
                        ? cn.viewed
                          ? 'text-grey'
                          : 'text-weight-medium'
                        : cn.viewed
                        ? 'text-grey'
                        : 'text-primary text-weight-medium'
                    "
                  >
                    {{ cn.message }}
                  </q-item-label>
                </q-item-section>
                <q-separator />
              </q-item>
            </q-list>
          </q-item-section>
        </q-item>
        <q-item
          v-if="combinedNotificationList.length > 0"
          clickable
          class="text-center"
          @click="this.$router.push({ name: 'UserNotification' })"
        >
          <q-item-section>
            <p class="text-body1 text-primary text-weight-regular q-ma-xs">
              View more
            </p>
          </q-item-section>
        </q-item>
      </q-list>

      <!-- <q-list>
        <q-item>
          <q-item-section>
            <q-list>
              <q-item
                v-for="gn in generalNotificationList"
                :key="gn.id"
                class="q-px-none cursor-pointer"
              >
                <q-item-section @click="onClickGeneralNotification(gn)">
                  <q-item-label
                    class="text-body1 text-weight-medium"
                    :class="
                      gn.viewed ? 'text-grey' : 'text-primary text-weight-bold'
                    "
                  >
                    {{ gn.title }}
                  </q-item-label>
                  <q-item-label
                    caption
                    lines="2"
                    :class="
                      gn.viewed
                        ? 'text-grey'
                        : 'text-primary text-weight-medium'
                    "
                  >
                    {{ gn.message }}
                  </q-item-label>
                </q-item-section>
                <q-separator />
              </q-item>
            </q-list>

            <q-separator />

            <q-list>
              <q-item
                v-for="sn in notificationList"
                :key="sn.id"
                class="q-px-none cursor-pointer"
              >
                <q-item-section @click="onClickNotification(sn)">
                  <q-item-label
                    class="text-body1 text-weight-medium"
                    :class="
                      sn.viewed ? 'text-grey' : 'text-primary text-weight-bold'
                    "
                  >
                    {{ sn.title }}
                  </q-item-label>
                  <q-item-label
                    caption
                    lines="2"
                    :class="
                      sn.viewed
                        ? 'text-grey'
                        : 'text-primary text-weight-medium'
                    "
                  >
                    {{ sn.message }}
                    <span v-if="sn.symbols && sn.symbols.length">
                      for {{ sn.symbols.join(", ") }}</span
                    >
                  </q-item-label>
                </q-item-section>
                <q-separator />
              </q-item>
            </q-list>
          </q-item-section>
        </q-item>
        <q-item
          v-if="
            notificationList.length > 0 || generalNotificationList.length > 0
          "
          clickable
          class="text-center"
          @click="this.$router.push({ name: 'UserNotification' })"
        >
          <q-item-section>
            <p class="text-body1 text-primary text-weight-regular q-ma-xs">
              View more
            </p>
          </q-item-section>
        </q-item>
      </q-list> -->
    </q-menu>
    <q-tooltip content="Notification" class="bg-primary">
      Notifications
    </q-tooltip>
  </q-btn>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";

import {
  isSupported,
  getToken,
  onMessage,
  getMessaging,
} from "firebase/messaging";
import firebaseApp from "boot/firebase";

import { PushNotifications } from "@capacitor/push-notifications";

import useNotifications from "src/use/notifications";
import { LocalStorage } from "quasar";

export default defineComponent({
  name: "NotificationBell",
  setup() {
    const router = useRouter();

    const {
      registerFCM,
      getNotifications,
      updateNotificationState,
      getGeneralNotifications,
    } = useNotifications();

    const notificationList = ref([]);
    const generalNotificationList = ref([]);
    const combinedNotificationList = ref([]);
    const unreadNotificationCount = ref(0);

    if (!LocalStorage.getItem("readGeneralNotifications")) {
      LocalStorage.set("readGeneralNotifications", new Array());
    }

    if (process.env.IS_CAPACITOR) {
      const addListeners = async () => {
        await PushNotifications.addListener("registration", (token) => {
          registerFCM(token.value);
        });

        await PushNotifications.addListener("registrationError", (err) => {
          console.error("Registration error: ", err.error);
        });

        await PushNotifications.addListener(
          "pushNotificationReceived",
          (notification) => {
            getAllNotifications();
          }
        );
        await PushNotifications.addListener(
          "pushNotificationActionPerformed",
          (notification) => {
            let routePage = notification?.notification?.data?.route;
            let symbol = notification?.notification?.data?.symbol;
            let signal = notification?.notification?.data?.signal;

            if (routePage) {
              let routeConfig = { name: routePage, query: {} };
              if (symbol) {
                routeConfig.query = { symbol: symbol };
              }
              if (signal) {
                routeConfig.query.signal = signal;
              }
              router.push(routeConfig);
            }
          }
        );
      };

      const registerNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === "prompt") {
          permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== "granted") {
          throw new Error("User denied permissions!");
        }

        await PushNotifications.register();
      };

      registerNotifications().then(() => {
        addListeners();
      });
    } else {
      const messaging = getMessaging(firebaseApp);
      isSupported().then((supported) => {
        if (supported) {
          getToken(messaging, {
            vapidKey:
              "BLHNpbTXUiAwDKFwS3_GCzPeZGuC6VQappJejjxVazj1FbNwUsMxEiharp8okGPhBrQUewm39B3Nby-9ygw9OtI",
          })
            .then((fcmToken) => {
              registerFCM(fcmToken);
            })
            .then(() => {
              onMessage(messaging, (payload) => {
                getAllNotifications();
              });
            })
            .catch((error) => {
              console.log("Firebase cloud messaging error", error);
            });
        } else {
          console.log("Firebase cloud messaging not supported");
        }
      });
    }

    function onClickNotification(notification) {
      updateNotificationState(notification.id, { viewed: true }).then((res) => {
        notificationList.value = notificationList.value.map((n) => {
          if (n.id == notification.id) {
            n.viewed = true;
          }
          return n;
        });
        router.push({
          name: "UserNotification",
          // hash: "#user-notifications",
        });
      });
    }

    function onClickGeneralNotification(notification) {
      generalNotificationList.value = generalNotificationList.value.map((n) => {
        if (n.id == notification.id) {
          n.viewed = true;
        }
        return n;
      });
      LocalStorage.set(
        "readGeneralNotifications",
        generalNotificationList.value.filter((n) => n.viewed).map((n) => n.id)
      );

      router.push({
        name: "GeneralNotification",
        // hash: "#general-notifications",
      });
    }
    function onClickCombineNotification(notification) {
      if (!notification.created_at) {
        updateNotificationState(notification.id, { viewed: true }).then(
          (res) => {
            res.data;
            combinedNotificationList.value = combinedNotificationList.value.map(
              (n) => {
                if (n.id == notification.id) {
                  n.viewed = true;
                }
                return n;
              }
            );
          }
        );
      }

      combinedNotificationList.value = combinedNotificationList.value.map(
        (n) => {
          if (n.id == notification.id) {
            n.viewed = true;
          }
          return n;
        }
      );
      LocalStorage.set(
        "readGeneralNotifications",
        combinedNotificationList.value.filter((n) => n.viewed).map((n) => n.id)
      );
      if (notification.click_url) {
        const originalUrl = "https://chukul.com/live-bulk-tnx-with-market";
        if (notification.title.includes("Live Bulk Txn (Mkt Opt)")) {
          notification.click_url = notification.click_url.replaceAll(
            originalUrl,
            "https://chukul.com/live-bulk-transaction-with-market-buy-sell"
          );
        } else {
          notification.click_url = notification.click_url.replaceAll(
            originalUrl,
            "https://chukul.com/live-bulk-transaction-with-market"
          );
        }

        if (notification.click_url.includes("https://chukul.com")) {
          const lastPart = notification.click_url.split("/").pop();
          const [path, queryString] = lastPart.split("?");
          router.push({
            path: `/${path}`,
            query: Object.fromEntries(new URLSearchParams(queryString)), // Convert the query string into a query object
          });
        }
        return;
      }
      if (notification.created_at) {
        router.push({
          name: "GeneralNotification",
        });
      } else {
        router.push({
          name: "UserNotification",
        });
      }
    }

    const getAllNotifications = () => {
      getNotifications().then((res) => {
        notificationList.value = res.data.slice(0, 5);
        combineAndSortData();
      });

      getGeneralNotifications().then((res) => {
        generalNotificationList.value = res.data.slice(0, 5).map((obj) => {
          obj.date = obj.created_at;
          return obj;
        });

        combineAndSortData();
      });

      function combineAndSortData() {
        combinedNotificationList.value = notificationList.value
          .concat(generalNotificationList.value)
          .map((n) => {
            if (LocalStorage.getItem("readGeneralNotifications").includes(n.id))
              n.viewed = true;
            else n.viewed = false;
            return n;
          });

        combinedNotificationList.value.sort(function (a, b) {
          let dateA = new Date(a.date);
          let dateB = new Date(b.date);
          return dateB - dateA;
        });
      }
    };

    onMounted(() => {
      getAllNotifications();
    });

    watch(
      [generalNotificationList, notificationList, combinedNotificationList],
      (
        [
          newGeneralNotificationList,
          newNotificationList,
          newCombinedNotification,
        ],
        [
          oldGeneralNotificationList,
          oldNotificationList,
          oldCombinedNotificationList,
        ]
      ) => {
        // const notificationList =
        //   newGeneralNotificationList.concat(newNotificationList);

        const combinedNotificationList = newCombinedNotification;
        if (combinedNotificationList.length) {
          unreadNotificationCount.value = combinedNotificationList.filter(
            (n) => !n.viewed
          ).length;
        }
      }
    );

    return {
      onMessage,

      onClickGeneralNotification,
      onClickNotification,
      getAllNotifications,

      generalNotificationList,
      notificationList,
      unreadNotificationCount,

      combinedNotificationList,
      onClickCombineNotification,
    };
  },
});
</script>
